var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGamePerf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.42 4.92164L9.63308 9.1021M14.795 14.6116C16.1494 13.1589 16.98 11.1971 16.98 9.03831C16.98 4.56112 13.4073 0.931641 9.00002 0.931641C4.59279 0.931641 1.02002 4.56112 1.02002 9.03831C1.02002 11.1971 1.85069 13.1589 3.20504 14.6116M10.14 10.0516C10.14 10.6812 9.62962 11.1916 9.00002 11.1916C8.37042 11.1916 7.86002 10.6812 7.86002 10.0516C7.86002 9.42204 8.37042 8.91164 9.00002 8.91164C9.62962 8.91164 10.14 9.42204 10.14 10.0516Z",
    style: {
      stroke: "var(--color, currentColor)",
      fill: "none"
    },
    strokeLinecap: "round"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamePerf);
export default __webpack_public_path__ + "static/media/game_perf.bee6249a.svg";
export { ForwardRef as ReactComponent };